// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// PD-0002 Mix Inteligente (Fase 3a). Leitura das recomendacoes de categoria de um cliente.
// Autorizacao no backend: vendedor ve so os proprios; admin do tenant ve todos.

export const getMixRecomendacoes = async (
  clienteId: number,
  estrategia: MixEstrategiaType
): Promise<GetMixRecomendacoesType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/recomendacao', {
      params: { clienteId, estrategia },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getMixProdutos = async (
  categoria: string
): Promise<GetMixProdutosType | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/produtos', {
      params: { categoria },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// Contagem de oportunidades (recomendacoes de mix) por cliente, em lote. Alimenta o chamariz da
// listagem de Predicao quando o Mix esta desligado no tenant. Multivalorado clienteId via 'repeat'
// (?clienteId=1&clienteId=2), casando com @RequestParam List<Long> no backend. Retorna
// { [clienteId]: total }; clientes sem oportunidade nao vem no mapa (tratar ausencia como 0).
export const getMixContagem = async (
  clienteId: number[]
): Promise<Record<number, number> | { message: string }> => {
  try {
    const result = await apiService.get('app/mix/contagem', {
      params: { clienteId },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// PD-0002 Fase 3b - feedback do vendedor (util/nao util) sobre uma recomendacao.
export const postMixFeedback = async (
  clienteId: number,
  categoria: string,
  util: boolean
): Promise<{ ok: true } | { message: string }> => {
  try {
    const result = await apiService.post('app/mix/feedback', {
      clienteId,
      categoria,
      util,
    })
    if (result.status === 200) {
      return { ok: true }
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}
